<template>
<div>
  <div class="title-h3 title-bar">{{selectServerTitle}}</div>
  <hr class="mr-b20" />
  <el-row class="title-bar" type="flex" justify="space-between">
    <div class="title-h4 dot-title">과점유 설정</div>
    <div>
      <el-button :disabled="!isEdit" size="small" type="primary" @click="occupySave">저장</el-button>
      <el-button :disabled="!isEdit" class="cmp-margin-left" size="small" @click="occupyCancel">취소</el-button>
    </div>
  </el-row>
  <div class="gray-box mr-b30" style="text-align:left">
    <span class="tit">메모리 과점유 사용량 (MB)</span>
    <el-input-number class="mr-r15" style="width:100px;" v-model="occupySetting.processMaxMemLimit" controls-position="right" placeholder="입력해 주세요." :min="1" @change="checkMemLimitEdit"></el-input-number>
    <span class="tit">CPU 과점유 사용률 (%)</span>
    <el-input-number style="width:100px;" v-model="occupySetting.processMaxCpuLimit" controls-position="right" placeholder="입력해 주세요." :min="1" :max="100" @change="checkMemLimitEdit" ></el-input-number>
  </div>
  <el-row class="title-bar" type="flex" justify="space-between">
    <div class="vertical-center-box">
      <div class="title-h4 dot-title">과점유 예외 프로세스 목록</div>
      <div class="setting-addel mr-l15">
        <el-button size="mini" @click="applyOccupyProc()"><i class="fas fa-plus"></i></el-button>
        <el-button size="mini" :disabled="!isDeleted" @click="deleteOccupyProc()"><i class="fas fa-minus"></i></el-button>
      </div>
    </div>
    <div>
      <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </div>
  </el-row>
  <el-table-wrapper @selection-change="exceptChangeSelection" :data="dataList" row-class-name="c-dblclick" :columns="occupyColumns"
    :pagination="false" :show-custom-header="true" :show-search-tool="showSearchTool" @row-dblclick="editOccupyProc" style="width:100%;">
  </el-table-wrapper>
  <w-except-occupy-list-popup ref="occupyExceptPopup" @reload-data="loadData" :popup-type="occupyExceptPopupType" :popupParam="popupParam" :editRow="editRow" @close="popupClose"></w-except-occupy-list-popup>
</div>
</template>

<script>
import msgUtil from '@/utils/message';
import { mapGetters } from 'vuex';
import isNil from 'lodash/isNil';
import moment from 'moment';
import isEqual from 'lodash/isEqual';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import clone from 'lodash/clone';
import cloneDeep from 'lodash/cloneDeep';
import ServerSettingAPI from '@/api/settings/server/server-settings';
import WExceptOccupyListPopup from '@/views/settings/server/ProcessSettings/OligopolisticProcessSettingView/popup/ExceptOccupyListPopup';

export default {
  name: 'WProcOccupyView',
  components: {
    WExceptOccupyListPopup,
  },
  props: {
    selectPhysicalNode: Object,
  },
  data() {
    return {
      isDeleted: false,
      isEdit: false,
      editRow: {},
      showSearchTool: false,
      dataList: null,
      changeExceptList: [],
      occupyExceptPopupType: null,
      selectServerTitle: '',
      occupySetting: {
        processMaxMemLimit: null,
        processMaxCpuLimit: null,
      },
      popupParam: {
        serverId: null,
        objId: null,
      },
      defaultOccupy: {},
      params: {
        serverId: null,
      },
      occupyColumns: [
        {
          align: 'center',
          type: 'selection',
          headerAlign: 'center',
        },
        {
          prop: 'processName',
          label: '프로세스 명',
          sortable: true,
          headerAlign: 'center',
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'processDesc',
          label: '예외 사유',
          width: 200,
          sortable: true,
          headerAlign: 'center',
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          label: '제외 시간 설정',
          width: 700,
          sortable: false,
          headerAlign: 'center',
          searchable: false,
          childColumns: [
            {
              prop: 'startTime',
              label: '시작 시각',
              width: 350,
              headerAlign: 'center',
              align: 'center',
              sortable: true,
              searchable: false,
              formatter: this.convertDatetime,
            },
            {
              prop: 'endTime',
              label: '종료 시각',
              width: 350,
              headerAlign: 'center',
              align: 'center',
              sortable: true,
              searchable: false,
              formatter: this.convertDatetime,
            },
          ],
        },
      ],
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    selectPhysicalNode: {
      handler() {
        if (!isNil(this.selectPhysicalNode)) {
          this.selectServerTitle = `[${this.selectPhysicalNode.label}] 프로세스 과점유 설정`;
          this.params.serverId = this.selectPhysicalNode.serverId;
          this.loadData();
        }
      },
      immediate: true,
    },
    changeExceptList: {
      handler() {
        if (this.changeExceptList.length > 0) {
          this.isDeleted = true;
        } else {
          this.isDeleted = false;
        }
      },
      immediate: true,
    },
  },
  methods: {
    loadData() {
      const me = this;
      me.popupParam.serverId = me.params.serverId;
      if (Object.keys(this.selectPhysicalNode).indexOf('obj') > 0) {
        me.popupParam.objId = this.selectPhysicalNode.obj.objId;
        ServerSettingAPI.getOverOccupy(me.params).then((response) => {
          if (response.data.success) {
            this.occupySetting = clone(response.data.data);
            this.defaultOccupy = clone(response.data.data);
            this.isEdit = false;
          }
        });
        ServerSettingAPI.getExceptProcess(me.params).then((response) => {
          if (response.data.success) {
            this.dataList = clone(response.data.data);
          }
        });
      }
    },
    popupClose() {
      this.editRow = {};
    },
    applyOccupyProc() {
      this.editRow = {};
      this.occupyExceptPopupType = 'ADD';
      this.$refs.occupyExceptPopup.open();
    },
    editOccupyProc(row) {
      this.editRow = cloneDeep(row);
      this.occupyExceptPopupType = 'EDIT';
      this.$refs.occupyExceptPopup.open();
    },
    deleteOccupyProc() {
      const target = '과점유 예외 프로세스';
      this.$confirm('삭제하시겠습니까?', '삭제', {
        confirmButtonText: '삭제',
        cancelButtonText: '취소',
      }).then(() => {
        ServerSettingAPI.deleteExceptProcess(this.changeExceptList).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, target, true));
            this.loadData();
          }
        });
      });
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    convertDatetime(row, column, value) {
      if (isNil(value)) {
        return EMPTY_TEXT;
      }
      return moment(new Date(value)).format('HH:mm');
    },
    checkMemLimitEdit() {
      const memCheck = isEqual(this.occupySetting.processMaxMemLimit, this.defaultOccupy.processMaxMemLimit);
      const cpuCheck = isEqual(this.occupySetting.processMaxCpuLimit, this.defaultOccupy.processMaxCpuLimit);
      if (memCheck && cpuCheck) {
        this.isEdit = false;
      } else {
        this.isEdit = true;
      }
    },
    occupySave() {
      const me = this;
      const action = msgUtil.action.SAVE;
      const target = '과점유 설정';
      const occupyParams = {
        processMaxMemLimit: me.occupySetting.processMaxMemLimit,
        processMaxCpuLimit: me.occupySetting.processMaxCpuLimit,
        serverId: me.params.serverId,
      };
      ServerSettingAPI.updateOverOccupy(occupyParams).then((response) => {
        if (response.data.success) {
          me.loadData();
          me.isEdit = false;
          this.$message(msgUtil.getResultMsgData(action, target, true));
        } else {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(action, target, false));
      });
    },
    occupyCancel() {
      this.occupySetting = clone(this.defaultOccupy);
      this.isEdit = false;
    },
    exceptChangeSelection(selectVal) {
      this.changeExceptList = selectVal;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/server/ProcessSettings/OligopolisticProcessSettingView/component/ProcOccupyView.vue